import React from 'react';
const { useState, useRef } = React;
import { gmailStoredText, withheldGmailOf } from '../../outreachEvidence.js';

// Before a function that needs the text of emails generates anything (continue a thread, answer a reply, read the
// replies of a report): the Gmail activities it would use are listed, unchecked, and only the ones Ale marks go to
// the AI (src/outreachEvidence.js › aiTextOf). «Generar sin texto de correos» is the first option; nothing is
// included by default and nothing is remembered: every generation asks again.
//   const choice = useGmailTextChoice();  …  const allow = await choice.ask(records, { purpose, nameOf });  if (!allow) return;
//   … aiTextOf(o, allow) …   and render {choice.element}
const fmt = (d) => { try { return new Date(d).toLocaleDateString('es', { day: 'numeric', month: 'short' }); } catch { return d || ''; } };

export function useGmailTextChoice() {
  const [state, setState] = useState(null); // { items, purpose, nameOf }
  const [picked, setPicked] = useState(new Set());
  const resolver = useRef(null);
  const ask = (records, { purpose = '', nameOf = null } = {}) => {
    const items = withheldGmailOf(records);
    if (!items.length) return Promise.resolve(new Set()); // nothing withheld: no question
    setPicked(new Set());
    return new Promise((resolve) => { resolver.current = resolve; setState({ items, purpose, nameOf }); });
  };
  const finish = (value) => { const r = resolver.current; resolver.current = null; setState(null); r?.(value); };
  const element = state ? (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Texto de correos para la IA" onClick={() => finish(null)} style={{ zIndex: 2100 }}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 560, display: 'grid', gap: 10 }}>
        <b style={{ fontSize: 15 }}>¿Incluir texto de correos?</b>
        <div style={{ fontSize: 13 }}>{state.purpose || 'Esta función funciona mejor con el texto de los correos.'} Por defecto no se envía: marcá solo lo que quieras incluir.</div>
        <div style={{ display: 'grid', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
          {state.items.map(o => (
            <label key={o.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, border: '1px solid var(--globant-border)', borderRadius: 8, padding: 8 }}>
              <input type="checkbox" checked={picked.has(o.id)} onChange={e => setPicked(p => { const n = new Set(p); e.target.checked ? n.add(o.id) : n.delete(o.id); return n; })} />
              <span style={{ minWidth: 0 }}>
                <b>{fmt(o.fields?.Date)} · {o.fields?.Channel || 'Email'} · {/received|replied/i.test(String(o.fields?.Status || '')) ? 'recibido' : 'enviado'}</b>{state.nameOf ? ` · ${state.nameOf(o)}` : ''}
                <span style={{ display: 'block', color: 'var(--globant-muted)', overflowWrap: 'anywhere' }}>{gmailStoredText(o).slice(0, 160)}{gmailStoredText(o).length > 160 ? '…' : ''}</span>
              </span>
            </label>
          ))}
        </div>
        <div style={{ fontSize: 11, color: 'var(--globant-muted)' }}>Se envía solo el texto guardado de lo marcado (asunto y fragmento, o el cuerpo enviado desde Oike), nunca adjuntos. Los registros no cambian.</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button type="button" className="action-btn btn-primary" onClick={() => finish(new Set())}>Generar sin texto de correos</button>
          <button type="button" className="action-btn" disabled={!picked.size} onClick={() => finish(new Set(picked))}>Generar con lo marcado ({picked.size})</button>
          <button type="button" className="action-btn btn-ghost" onClick={() => finish(null)}>Cancelar</button>
        </div>
      </div>
    </div>
  ) : null;
  return { ask, element };
}
